import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import SiteFooter from '../includes/SiteFooter';

class PagePreferencesShowHide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const popoverBottom = (
      <Popover id="popover-positioned-bottom">
        <button type="button" className="close" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
        <strong>Holy guacamole!</strong> Check this info.
      </Popover>
    );

    return (
      <div>
        <div id="site-main" className="page bow" role="main" tabIndex="-1">
          <div className="container" id="site-main-container">
            <div className="row">
              <div className="col-md1-24">
                <div className="c-step-header">
                  <p className="c-step-header__crumbs">
                    <a
                      className="c-step-header__link"
                      href=""
                      onClick={this.props.closed}
                    >
                      <span className="icon icon-page-back c-step-header__linkicon" />
                      <span className="c-step-header__linktext">Back</span>
                    </a>
                  </p>
                  <h2
                    className="c-step-header__title"
                    id="page-preferences-showhide-heading"
                  >
                    Show or hide your accounts
                  </h2>
                </div>

                <p>
                  Choose which accounts you want to be available within mobile
                  and internet banking.
                </p>

                <div className="c-account c-account--preferences c-account--is-disabled l-preferences">
                  <div className="l-preferences__account">
                    <h3 className="c-account__name">Savings</h3>

                    <dl className="c-account__defs">
                      <dt className="c-account__term">Sortcode</dt>
                      <dd className="c-account__sortno">23-44-61</dd>
                      <dt className="c-account__term">Account number</dt>
                      <dd className="c-account__accountno">413423466</dd>
                      <dt className="c-account__term">Balance</dt>
                      <dd className="c-account__balance">&pound;1,200.50</dd>
                    </dl>
                  </div>
                  <div className="l-preferences__preferences">
                    <div className="c-account__controls">
                      <div className="c-account__controls-top">
                        <OverlayTrigger
                          container={this}
                          trigger="click"
                          placement="bottom"
                          overlay={popoverBottom}
                        >
                          <a href="javascript:void(0)" className="tooltip-icon">
                            <svg width="24px" height="24px" viewBox="0 0 24 24">
                              <g
                                id="Supplemental-Icons"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <g
                                  id="circle-information-24"
                                  transform="translate(-1.000000, -1.000000)"
                                  stroke="#000000"
                                  strokeWidth="2"
                                >
                                  <path
                                    d="M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,10 L12,18 M12,6 L12,8"
                                    id="Group"
                                  />
                                </g>
                              </g>
                            </svg>
                          </a>
                        </OverlayTrigger>
                      </div>

                      <label
                        htmlFor="cb1"
                        className="c-account__controls-middle a-label"
                      >
                        <input
                          disabled="disabled"
                          className="a-checkbox"
                          id="cb1"
                          name="cb1"
                          defaultChecked
                          type="checkbox"
                        />
                        <span>
                          <span className="u-visually-hidden off-screen">
                            Shown
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="c-account c-account--preferences l-preferences">
                  <div className="l-preferences__account">
                    <h3 className="c-account__name">Savings</h3>

                    <dl className="c-account__defs">
                      <dt className="c-account__term">Sortcode</dt>
                      <dd className="c-account__sortno">23-44-61</dd>
                      <dt className="c-account__term">Account number</dt>
                      <dd className="c-account__accountno">413423466</dd>
                      <dt className="c-account__term">Balance</dt>
                      <dd className="c-account__balance">&pound;1,200.50</dd>
                    </dl>
                  </div>
                  <div className="l-preferences__preferences">
                    <div className="c-account__controls">
                      <label
                        htmlFor="cb2"
                        className="c-account__controls-middle a-label"
                      >
                        <input
                          className="a-checkbox"
                          id="cb2"
                          name="cb2"
                          defaultChecked
                          type="checkbox"
                        />
                        <span>
                          <span className="u-visually-hidden off-screen">
                            Shown
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="c-account c-account--preferences l-preferences">
                  <div className="l-preferences__account">
                    <h3 className="c-account__name">Savings</h3>

                    <dl className="c-account__defs">
                      <dt className="c-account__term">Sortcode</dt>
                      <dd className="c-account__sortno">23-44-61</dd>
                      <dt className="c-account__term">Account number</dt>
                      <dd className="c-account__accountno">413423466</dd>
                      <dt className="c-account__term">Balance</dt>
                      <dd className="c-account__balance">&pound;1,200.50</dd>
                    </dl>
                  </div>
                  <div className="l-preferences__preferences">
                    <div className="c-account__controls">
                      <label
                        htmlFor="cb3"
                        className="c-account__controls-middle a-label"
                      >
                        <input
                          className="a-checkbox"
                          id="cb3"
                          name="cb3"
                          defaultChecked
                          type="checkbox"
                        />
                        <span>
                          <span className="u-visually-hidden off-screen">
                            Shown
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="callout">
                  <p>
                    Deselecting accounts will mean that their transactions and
                    the ability to move money from them won’t be available
                    within [internet banking | B on Web].
                  </p>
                </div>

                <div className="form-actions">
                  <a href="" className="c-btn c-btn--secondary">
                    Back
                  </a>
                  <button
                    type="submit"
                    href=""
                    className="c-btn c-btn--default"
                  >
                    Confirm changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <SiteFooter />
      </div>
    );
  }
}

export default PagePreferencesShowHide;
